// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.checkout-payment-type-container {\n  width: 17rem;\n}\n@media (max-width: 670px) {\n.checkout-payment-type-container {\n    width: 20rem;\n}\n}\n.uil-qrcode-scan {\n  font-size: 22px;\n}\n", ""]);
// Exports
module.exports = exports;
